import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/year-in-pictures-2024/year-in-pictures.scss";
import customConfirmationYIP2024 from "../../../../src/content/year-in-pictures-2024/customConfirmation";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationYIP2024,
  React
};